export enum ShadowToken {
  shadowLevel1 = '0 0.4rem 0.8rem rgba(0, 0, 0, 0.08)',
  shadowLevel2 = '0 0.8rem 2.4rem rgba(0, 0, 0, 0.08)',
  shadowLevel3 = '0 1.6rem 4.8rem rgba(0, 0, 0, 0.08)',
}

export default ShadowToken

export type TShadow = 'shadowLevel1' | 'shadowLevel2' | 'shadowLevel3'
